export const onUpdateVideoVotesUI = /* GraphQL */ `
    subscription OnUpdateVideoVotes {
        onUpdateVideoVotes {
            id
            votes
            videoID
        }
    }
`;
